export function initiateSocketConnection() {
  if (!$nuxt.$socket.connected) {
    $nuxt.$socket.connect();
  }
}
